import { render, staticRenderFns } from "./UpdateMerchantSettingsModal.vue?vue&type=template&id=a01dc9b8&scoped=true&"
import script from "./UpdateMerchantSettingsModal.vue?vue&type=script&lang=js&"
export * from "./UpdateMerchantSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMerchantSettingsModal.vue?vue&type=style&index=0&id=a01dc9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01dc9b8",
  null
  
)

export default component.exports